import React, { useState, useEffect, useRef } from "react"
import { connect } from "react-redux"
import * as firebase from "firebase"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  Container,
} from "reactstrap"

import IndexNavbar from "components/Navbars/IndexNavbar.js"
import Footer from "components/Footers/Footer.js"

function EmailVerify({ email, emailVerified }) {
  const [disabled, setDisabled] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  let timeoutId = useRef(0)

  // useEffect(() => {
  //   if (firebase.auth().currentUser && emailVerified === false) {
  //     firebase.auth().currentUser.sendEmailVerification()
  //     .then(() => {
  //       console.log('Verification Email Sent');
  //       setEmailSent(true);
  //       setDisabled(true);
  //     })
  //     .catch((err) => {
  //       console.log(`Verification Email Not Sent. Error:\n${err}`);
  //       setEmailSent(true);
  //     });
  //   }
  // }, [emailVerified]);

  useEffect(() => {
    console.log("Debug-0")
    timeoutId.current = setTimeout(() => {
      console.log("Debug-1")
      console.log(disabled, emailSent, emailVerified)
      if (disabled && emailSent && emailVerified === false) {
        console.log("Disabling Reset")
        setDisabled(false)
      }
    }, 60 * 1000)
    if (emailVerified) {
      clearTimeout(timeoutId)
    }
    return () => clearTimeout(timeoutId)
  }, [disabled, emailSent, emailVerified])

  useEffect(() => {
    if (emailVerified) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          console.log("User Logged Out.")
          window.location.replace("/a/login")
          // dispatch({ type: "logout", payload: false });
        })
        .catch((err) => {
          console.log(`Error Logging Out User. Error:\n${err}`)
          // alert(err);
        })
    }
  }, [emailVerified])

  return (
    <>
      <div className="bg-chift hero-chift">
        <IndexNavbar />
        <div className="main-content">
          <Container>
            <br />
            <br />
            <Row className="justify-content-center">
              {emailVerified === true ? (
                <>
                  <Col md="8">
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-3" tag="h3">
                          Email Verified!
                        </CardTitle>
                        <CardText className="mb-4">
                          You will be redirected shortly to Login Page.
                        </CardText>
                      </CardBody>
                    </Card>
                  </Col>
                </>
              ) : emailVerified === false ? (
                <>
                  <Col md="8">
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-3" tag="h3">
                          Verify Email
                        </CardTitle>
                        <CardText className="mb-4">
                          We sent an email to {email}
                          <br />
                          To continue, please check your email and verify you
                          account.
                        </CardText>
                        <CardText>Didn't receive the email?</CardText>
                        <Button
                          color="primary"
                          onClick={(e) => {
                            e.preventDefault()
                            if (firebase.auth().currentUser && !emailVerified) {
                              firebase
                                .auth()
                                .currentUser.sendEmailVerification()
                                .then(() => {
                                  console.log("Verification Email Sent")
                                  setEmailSent(true)
                                  setDisabled(true)
                                })
                                .catch((err) => {
                                  console.log(
                                    `Verification Email Not Sent. Error:\n${err}`
                                  )
                                  setEmailSent(true)
                                })
                            }
                          }}
                          disabled={disabled}
                        >
                          Resend Email
                        </Button>
                      </CardBody>
                    </Card>
                  </Col>
                </>
              ) : null}
            </Row>
          </Container>
        </div>
        <Footer transparent />
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    emailVerified: state.firebase.auth.emailVerified,
    email: state.firebase.auth.email,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerify)
